module.exports = {
    onBoardContent: [
        {
            id: 1,
            img: 'mac_report',
            mobImg:'mob_mac_report',
            folder:'Assets',
            btnText: 'LEARN MORE',
            paddingLeft: '21px',
            header:'Welcome to MyGame',
            page:'LearnMore',
            style:{marginTop: '-22px',paddingLeft: '22px'},
            content: '80% of players who used MyGame saw an immediate improvement in their game!',

        },
        {
            id: 2,
            img: 'headphones_glasses_robo',
            mobImg:'',
            folder:'Assets',
            btnText: 'CONTINUE',
            header: 'Meet MyGame Whiz',
            page:'MeetMygameWhiz',
            content: 'Your virtual poker coach! His in-game analysis & live hand feed will take your game to the next level!',

        },
        {
            id: 3,
            img: 'mob_report',
            mobImg:'',
            folder:'Assets',
            btnText: 'CONTINUE',
            header: 'My Report Cards',
            page:'MyReport',
            style:{height: '-webkit-fill-available', width: '298.26px',},
            content: 'Your report cards provide deep insight into your game & will teach you how to level up. ',

        },
        {
            id: 4,
            img: 'myStats_myHands',
            mobImg:'',
            folder:'Assets',
            btnText: 'CONTINUE',
            header: 'MyStats & MyHands',
            paddingTop:'29px',
            page:'MyStatsMyHands',
            style:{paddingTop: '19px'},
            content: `Analyse your game statistics with MyStats.\n
            Favourite, share, manage & more with MyHands.`
        },
        {
            id: 5,
            img: 'mac_course',
            mobImg:'',
            folder:'Assets',
            btnText: 'GET STARTED',
            header: 'Courses',
            page:'Courses',
            paddingLeft: '20px',
            style:{paddingTop: '11px'},
            content: `In poker, knowledge is power.\n
            Deep dive into the game of poker with courses.`
        },
    ]
}


/** WEBPACK FOOTER **
 ** ./src/components/MygameOnBoard/mygameOnBoardContent.js
 **/